import { Routes } from '@angular/router';

import { SERVICE_ANALYTICS } from '../shared/models/list';
import { ListFilterComponent } from '../shared/components/filter/list-filter.component';

import { guaranteeGuard } from './components/guards/guarantee.guard';
import { guaranteeRequestResolver } from './resolvers/guarantee-request.resolver';
import { GuaranteeListComponent } from './components/list/guarantee-list.component';
import { GuaranteeRequestCardComponent } from './components/card/guarantee-request-card.component';
import { ProjectEnvironmentComponent } from './components/entry/step-2/project-environment.component';
import { TypeOfGuaranteeComponent } from './components/entry/step-3/type-of-guarantee.component';
import { GuaranteeDraftsComponent } from './components/list/guarantee-drafts.component';
import { GuaranteeTypeSelectorComponent } from './components/entry/step-1/guarantee-type-selector.component';
import { ProjectCharacteristicsComponent } from './components/entry/step-1/project-characteristics.component';
// eslint-disable-next-line @stylistic/max-len
import { GuaranteeRequestConfirmationComponent } from './components/entry/step-4/guarantee-request-confirmation.component';

export const routes: Routes = [
	{
		path: '',
		canActivate: [guaranteeGuard],
		data: { pageName: 'Redirect', service: SERVICE_ANALYTICS.GUARANTEE },
		children: [
			{
				path: 'new/guarantee-type-selector',
				component: GuaranteeTypeSelectorComponent,
				data: { pageName: 'Guarantee Requests - Type Selector', service: SERVICE_ANALYTICS.GUARANTEE }
			},
			{
				path: 'new',
				resolve: {
					guarantee: guaranteeRequestResolver,
				},
				children: [
					{
						path: 'project-characteristics',
						component: ProjectCharacteristicsComponent,
						// eslint-disable-next-line @stylistic/max-len
						data: { pageName: 'Guarantee Requests - New Characteristics', service: SERVICE_ANALYTICS.GUARANTEE }
					},
					{
						path: 'project-environment',
						component: ProjectEnvironmentComponent,
						data: { pageName: 'Guarantee Requests - New Environment', service: SERVICE_ANALYTICS.GUARANTEE }
					},
					{
						path: 'guarantee-request-confirmation',
						component: GuaranteeRequestConfirmationComponent,
						data: {
							pageName: 'Guarantee Requests - New Confirmation',
							service: SERVICE_ANALYTICS.GUARANTEE
						}
					},
					{
						path: 'type-of-guarantee',
						component: TypeOfGuaranteeComponent,
						// eslint-disable-next-line @stylistic/max-len
						data: { pageName: 'Guarantee Requests - New Type of Guarantee', service: SERVICE_ANALYTICS.GUARANTEE }
					}
				]
			},
			{
				path: 'edit/:guaranteeId',
				resolve: {
					guarantee: guaranteeRequestResolver,
				},
				children: [
					{
						path: 'project-characteristics',
						component: ProjectCharacteristicsComponent,
						data: {
							pageName: 'Guarantee Requests - Edit Characteristics',
							service: SERVICE_ANALYTICS.GUARANTEE
						}
					},
					{
						path: 'project-environment',
						component: ProjectEnvironmentComponent,
						// eslint-disable-next-line @stylistic/max-len
						data: { pageName: 'Guarantee Requests - Edit Environment', service: SERVICE_ANALYTICS.GUARANTEE }
					},
					{
						path: 'type-of-guarantee',
						component: TypeOfGuaranteeComponent,
						data: {
							pageName: 'Guarantee Requests - Edit Type of Guarantee',
							service: SERVICE_ANALYTICS.GUARANTEE
						}
					},
					{
						path: 'guarantee-request-confirmation',
						component: GuaranteeRequestConfirmationComponent,
						data: {
							pageName: 'Guarantee Requests - Edit Confirmation',
							service: SERVICE_ANALYTICS.GUARANTEE
						}
					}
				]
			},
			{
				path: 'list',
				resolve: {
					claim: guaranteeRequestResolver,
				},
				children: [
					{
						path: '',
						component: GuaranteeListComponent,
						data: {
							pageName: 'Guarantee Requests - List',
							service: SERVICE_ANALYTICS.GUARANTEE,
							type: 'guarantee',
						}
					},
					{
						path: 'filter',
						component: ListFilterComponent,
						data: { pageName: 'Guarantee Requests - Filter', service: SERVICE_ANALYTICS.GUARANTEE }
					}
				]
			},
			{
				path: 'card/:guaranteeId',
				resolve: {
					guarantee: guaranteeRequestResolver,
				},
				component: GuaranteeRequestCardComponent,
				data: { pageName: 'Guarantee Requests - Guarantee Request Card', service: SERVICE_ANALYTICS.GUARANTEE }
			},
			{
				path: 'drafts',
				resolve: {
					claim: guaranteeRequestResolver,
				},
				children: [
					{
						path: '',
						component: GuaranteeDraftsComponent,
						data: {
							pageName: 'Guarantee Requests - Drafts List',
							service: SERVICE_ANALYTICS.GUARANTEE,
							type: 'guarantee'
						}
					}
				]
			}
		]
	}
];
